import { forwardRef } from "react";
import { Link as RouterLink, type LinkProps as RouterLinkProps } from "react-router";

export type RouterLinkBehaviorProps = Omit<RouterLinkProps, "to"> & {
  href?: RouterLinkProps["to"];
};

/**
 * Anchor-shaped adapter over react-router's `Link`.
 *
 * MUI's `Link` and `ButtonBase` take the destination as `href`; react-router's
 * `Link` takes it as `to`. Translating between the two here means design-system
 * components never import a router — they render a plain anchor by default and
 * accept any anchor-shaped component through a `linkComponent` prop.
 *
 * @example
 * <SrTile url={path$("/projects/:key", { key })} linkComponent={RouterLinkBehavior}>
 */
export const RouterLinkBehavior = forwardRef<HTMLAnchorElement, RouterLinkBehaviorProps>(
  function RouterLinkBehavior({ href, ...props }, ref) {
    return <RouterLink ref={ref} to={href ?? ""} {...props} />;
  },
);
